import { BrowserRouter } from 'react-router-dom';
import { type ReactNode } from 'react';
import { QueryProvider } from './providers/QueryProvider.js';
import { ToastProvider } from '@shared/ui/Toast/Toast.js';
import { AuthProvider, useAuth } from './providers/AuthProvider.js';
import { ThemeManager } from './theme/ThemeManager.js';
import { AppRoutes } from './router/routes.js';
import { EnteringSplash } from '@shared/ui/EnteringSplash/EnteringSplash.js';

/**
 * Gates the router behind the auth bootstrap so the Login page never renders while
 * the handoff exchange is in progress — instead showing the IAM-matching black splash.
 * Must be a child of AuthProvider to consume useAuth().
 */
function AuthGate({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === 'loading') return <EnteringSplash name="Gestor de ligas y torneos" />;
  return <>{children}</>;
}

export function App() {
  return (
    <BrowserRouter>
      <QueryProvider>
        <ToastProvider>
          <AuthProvider>
            <ThemeManager />
            <AuthGate>
              <AppRoutes />
            </AuthGate>
          </AuthProvider>
        </ToastProvider>
      </QueryProvider>
    </BrowserRouter>
  );
}
